@if (!mainPage) {
  <div>
    <div class="relative h-16 w-[241px] rounded-md border-2 border-aux-gray-dark bg-white">
      <label for="portfolio-trial-select" class="absolute pl-5 pt-2 text-sm">Go To Trial</label>
      <ng-select
        #trialDropdownEl
        id="portfolio-trial-select"
        bindValue="id"
        bindLabel="short_name"
        class="trial-select portfolio-trial-select h-full"
        placeholder="Select Trial"
        [formControl]="trialFormControl"
        [clearable]="false"
        [items]="sortedTrials()"
        [groupBy]="groupByFn()"
        (ngModelChange)="onChange(trialFormControl.value)"
        (open)="focusSearchInput()"
      >
        <ng-template ng-header-tmp>
          <aux-input
            placeholder="Search"
            icon="Search"
            iconPosition="left"
            iconClassName="search-input-icon"
            inputClassName="search-input"
            (keyup)="isKeyEvent($event) ? trialDropdownEl.filter($event.target.value) : undefined"
          />
        </ng-template>
        <ng-template let-item="item" let-clear="clear" ng-option-tmp class="flex-nowrap">
          <div class="option-wrapper flex items-center">
            @if (typecastingForTrialStatus(item.implementation_status); as implementation_status) {
              <div>
                <div
                  class="mr-2 h-2 w-2 min-w-2 shrink-0 rounded-full"
                  [ngStyle]="{ 'background-color': trialStatusMap[implementation_status].color }"
                  auxTooltip
                  [template]="tooltipTemplate"
                  [clearTemplate]="true"
                  (mouseenter)="mouseEnter(implementation_status)"
                  [auxTooltipPositions]="[tooltipPosition]"
                ></div>
              </div>
            }
            <div
              class="mr-[15px] truncate"
              [ngClass]="{
                'font-bold': !item.implementation_status,
                'font-medium': item.implementation_status,
              }"
              #homePageOption
              [auxTooltip]="
                homePageOption.offsetWidth < homePageOption.scrollWidth ? item.short_name : ''
              "
              [auxTooltipPositions]="[tooltipPosition]"
            >
              {{ item.short_name }}
            </div>
          </div>
        </ng-template>
      </ng-select>
    </div>
  </div>
} @else {
  <div class="absolute grid h-[24px] w-[24px] place-content-center text-aux-blue-light">
    <aux-icon [name]="selectedTrialIcon()" style="stroke-width: 1.5px"></aux-icon>
  </div>
  <div class="shrink-0" style="width: 213px">
    <label for="trial-select" class="absolute pl-[34px] text-xs font-medium">
      {{ selectedTrialLabel() }}
    </label>
    <ng-select
      #trialDropdownEl
      id="trial-select"
      class="trial-select w-full tabular-nums"
      [searchable]="false"
      [formControl]="trialFormControl"
      placeholder="Select Trial"
      [items]="sortedTrials()"
      [clearable]="false"
      [groupBy]="groupByFn()"
      bindLabel="short_name"
      bindValue="id"
      (ngModelChange)="onChange(trialFormControl.value)"
      (open)="focusSearchInput()"
    >
      <ng-template let-item="item" let-clear="clear" ng-label-tmp class="flex-nowrap">
        <div class="flex flex-col space-y-2" style="line-height: 1.25rem">
          <div
            class="z-10 mr-1 truncate pl-[34px] font-medium"
            #mainPageTrialLabel
            [auxTooltip]="
              mainPageTrialLabel.offsetWidth < mainPageTrialLabel.scrollWidth ? item.short_name : ''
            "
            [auxTooltipPositions]="[tooltipPosition]"
          >
            {{ item.short_name }}
          </div>
          <div class="flex flex-nowrap space-x-2 text-sm font-normal">
            <span class="flex align-bottom">Aux Status:</span>
            @if (typecastingForTrialStatus(item.implementation_status); as implementation_status) {
              <div>
                <div
                  [ngStyle]="{
                    color: trialStatusMap[implementation_status].color,
                    'overflow-x':
                      trialStatusMap[implementation_status].text === 'Implementation'
                        ? 'visible'
                        : '',
                    position:
                      trialStatusMap[implementation_status].text === 'Implementation'
                        ? 'absolute'
                        : '',
                  }"
                  class="flex items-center justify-start"
                >
                  <div
                    class="mr-1 h-[10px] w-[10px] shrink-0 rounded-full"
                    [ngStyle]="{ 'background-color': trialStatusMap[implementation_status].color }"
                  ></div>
                  <span>{{ trialStatusMap[implementation_status].text }}</span>
                </div>
              </div>
            }
          </div>
        </div>
      </ng-template>

      <ng-template ng-header-tmp>
        <aux-input
          placeholder="Search"
          icon="Search"
          iconPosition="left"
          iconClassName="search-input-icon"
          inputClassName="search-input"
          (keyup)="isKeyEvent($event) ? trialDropdownEl.filter($event.target.value) : undefined"
        />
      </ng-template>
      <ng-template let-item="item" let-clear="clear" ng-option-tmp class="flex-nowrap">
        <div (click)="selectTrial($event, item.id)" class="option-wrapper flex items-center">
          @if (typecastingForTrialStatus(item.implementation_status); as implementation_status) {
            <div>
              <div
                class="mr-2 h-2 w-2 min-w-2 shrink-0 rounded-full"
                [ngStyle]="{ 'background-color': trialStatusMap[implementation_status].color }"
                auxTooltip
                [template]="tooltipTemplate"
                [clearTemplate]="true"
                (mouseenter)="mouseEnter(implementation_status)"
                [auxTooltipPositions]="[tooltipPosition]"
              ></div>
            </div>
          }
          <div
            class="mr-[15px] truncate"
            [ngClass]="{
              'font-bold': !item.implementation_status,
              'font-medium': item.implementation_status,
            }"
            #mainPageOption
            [auxTooltip]="
              mainPageOption.offsetWidth < mainPageOption.scrollWidth ? item.short_name : ''
            "
            [auxTooltipPositions]="[tooltipPosition]"
          >
            {{ item.short_name }}
          </div>
        </div>
      </ng-template>
    </ng-select>
  </div>
}

<ng-template #tooltipTemplate>
  <div
    [ngStyle]="{ 'background-color': this.tooltipColor, color: this.tooltipTextColor }"
    style="padding: 0.5rem 1rem; border-radius: 4px; color: white"
  >
    <span>{{ this.tooltipValue }}</span>
  </div>
</ng-template>
